import { useTranslation } from 'react-i18next';
import './CommonRadioButton.scss';
import radioChecked from '../assets/images/radioCheckedIcon.svg';
import radioUnchecked from '../assets/images/radioUnCheckIcon.svg';

const CommonRadioWithLabel = ({ className = "", value, onChange, checked, label, name, id, disabled, ...props }) => {
   const { t, i18n } = useTranslation();
    const isRTL = i18n.language === 'ar' || i18n.dir() === 'rtl';
    const inputId = id || `common-radio-btn-id-${value}`;
    return (
        <div className={`common-radio-with-label ${className} ${isRTL ? 'rtl' : ''}`}>
            <input
                type="radio"
                id={inputId}
                className="common-radio-button"
                name={name}
                value={value}
                onChange={onChange}
                checked={checked}
                disabled={disabled}
                {...props}
            />
            <label className="common-radio-label" htmlFor={inputId}>
                <img
                    src={checked ? radioChecked : radioUnchecked}
                    alt="radio button"
                    className={`common-radio-icon ${disabled ? 'disabled' : ''}`}
                />
                {t(label)}
            </label>
        </div>
    );
};

export default CommonRadioWithLabel;
